import {stateData, reduxState} from '../../values';

export const getCompanies = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_companies,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateCompanies = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_companies,
            payload:    data,
        })
    }
}